import { useMemo } from 'react';
import { Info } from 'lucide-react';
import { Tooltip, TooltipTrigger, TooltipContent } from '@design-system';
import { useFundingSources } from '@/features/guided-financial-planning/hooks';
import { FundingSourceCard } from './funding-source-card';

export function FundingSourcesList() {
  const fundingSources = useFundingSources();
  const selfFunding = fundingSources?.selfFunding ?? {};

  // Filter to only show sources with existingAssetsValue (no empty shells)
  const validSources = useMemo(() => {
    return Object.entries(selfFunding).filter(([, source]) => {
      return source.existingAssetsValue != null && source.existingAssetsValue > 0;
    });
  }, [selfFunding]);

  if (validSources.length === 0) {
    return (
      <div className="py-8 text-center">
        <p className="text-sm text-gray-500">No funding sources available.</p>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            className="flex items-center gap-1.5 text-gray-900 hover:text-gray-700"
          >
            <span className="text-base font-semibold">Select funding accounts:</span>
            <Info className="size-4 text-gray-400" />
          </button>
        </TooltipTrigger>
        <TooltipContent
          side="top"
          className="max-w-xs space-y-2 p-3"
        >
          <p className="font-medium">Simplified estimate</p>
          <p>We're using your current account balances to estimate available funds.</p>
          <p className="text-gray-300">
            Coming soon: monthly contributions, investment growth, and tax considerations.
          </p>
        </TooltipContent>
      </Tooltip>
      {validSources.map(([selfFundingSourceId, source]) => (
        <FundingSourceCard
          key={selfFundingSourceId}
          selfFundingSourceId={selfFundingSourceId}
          selfFundingSource={source as SelfFundingSource}
        />
      ))}
    </div>
  );
}
